import { render, staticRenderFns } from "./B103.vue?vue&type=template&id=1ffb44fc&scoped=true"
import script from "./B103.vue?vue&type=script&lang=js"
export * from "./B103.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/Pdis.css?vue&type=style&index=0&id=1ffb44fc&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffb44fc",
  null
  
)

export default component.exports